import { stringToUint8Array } from '../utils/Utils';
import { type CryptoUtils } from './utils/CryptoUtils';

const AES_IV_LENGTH = 12;

export class ServerReplicantUserIDEncryption {
    private encryptionKeyPromise: Promise<CryptoKey> | undefined;

    constructor(private opts: { crypto: CryptoUtils }) {}

    async encryptUserId(userId: string): Promise<string> {
        const encryptionKey = await this.getEncryptionKey();

        const userIdHash = this.opts.crypto.createSHA256Hash(userId, 'hex');
        const iv = stringToUint8Array(userIdHash).slice(0, AES_IV_LENGTH);

        return this.opts.crypto.aesEncrypt(encryptionKey, userId, iv);
    }

    async decryptUserId(encryptedUserId: string): Promise<string> {
        const encryptionKey = await this.getEncryptionKey();

        return this.opts.crypto.aesDecrypt(encryptionKey, encryptedUserId, AES_IV_LENGTH);
    }

    private getEncryptionKey(): Promise<CryptoKey> {
        if (!this.encryptionKeyPromise) {
            if (!process.env.USER_ID_ENCRYPTION_KEY) {
                throw Error('USER_ID_ENCRYPTION_KEY environment variable is required for user ID encryption');
            }

            this.encryptionKeyPromise = this.opts.crypto.importAesKey(process.env.USER_ID_ENCRYPTION_KEY);
        }

        return this.encryptionKeyPromise;
    }
}
